// extracted by mini-css-extract-plugin
module.exports = {"comp":"JA_comp__admv_"};